import { render, staticRenderFns } from "./pop-ship.vue?vue&type=template&id=6c42b311&scoped=true&"
import script from "./pop-ship.vue?vue&type=script&lang=js&"
export * from "./pop-ship.vue?vue&type=script&lang=js&"
import style0 from "./pop-ship.vue?vue&type=style&index=0&id=6c42b311&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c42b311",
  null
  
)

export default component.exports